import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { colors } from '../../styles/theme';

interface ModalStickyFooterProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export default function ModalStickyFooter({ children, style }: ModalStickyFooterProps) {
  return <View style={[styles.footer, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  footer: {
    width: '100%',
    backgroundColor: colors.surface,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderTopWidth: 1,
    borderTopColor: '#e7eaf0',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
});
